import {BaseRouteMetaDataModel} from "../../../infrastructure/models/route/base-route.meta-data.model";
import {WebsiteModuleState} from "../../../apps/website/models/website-module.state";
import {WebsiteModuleStore} from "../../../apps/website/website-module-store";

export class BolaoRouteMetaDataModel extends BaseRouteMetaDataModel {
  get websiteModel(): WebsiteModuleState {
    return this.resolve(WebsiteModuleStore).state;
  }

  get pageTitle() {
    return this.websiteModel.terms.MD_TITLE_BOLAO_HOMEPAGE?.format({
      'bolaoName': this.websiteModel.terms.WC_2022_BOLAO_NAME
    });
  }

  get description() {
    return this.websiteModel.terms.MD_DESCRIPTION_BOLAO_HOMEPAGE;
  }
}
